'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var assetsHelper = require('../../helper/assetsHelper');
var i18nHelper = require('../../helper/i18n');
var appTypes = require('../../types/appTypes');

var SignCheckAlert = React.createClass({

    propTypes: {
        registKeyEvent: React.PropTypes.func.isRequired,
        onExitPaint: React.PropTypes.func.isRequired,
        sign: React.PropTypes.func.isRequired,
    },

    render: function () {

        return (
            <div className='pop-alert-cover' >
                <div className='sign-alert'>
                    <img className="close" src={assetsHelper.getAsset('close2.png')} onClick={this.props.onExitPaint}/>
                    <div className='top-box'>
                        <p className="text">{i18nHelper.get('SIGN_ALERT_MSG')}</p>
                    </div>
                    <div className="bottom-box">
                        <input type='text' ref='sign' className='sign-text' />
                        <input type='button' className='sign-button' onClick={this.sign} value={i18nHelper.get('BUTTON_SURE')} />
                    </div>
                    <span className='msg'>{i18nHelper.get('SIGN_TIP')}</span>
                </div>
            </div>

        );
    },

    componentDidMount: function() {
        var node = ReactDOM.findDOMNode(this.refs.sign);
        var context = this;
        $(node).focus();
        this.props.registKeyEvent(13, function () {
                context.sign();
        });
    },

    componentDidUpdate: function() {
        var context = this;
        this.props.registKeyEvent(13, function() {
            context.sign();
        });
    },

    sign: function() {
        var node = ReactDOM.findDOMNode(this.refs.sign);
        var value = $(node).val();
        if(value) {
            this.props.sign(value);
        } else {
            $(node).focus();
        }
    }

});

module.exports = SignCheckAlert;



// WEBPACK FOOTER //
// ./src/views/Review/SignCheckAlert.jsx